import actionCreatorFactory from 'typescript-fsa';
import * as type from '../types/category';
var actionCreator = actionCreatorFactory();
export var requestCategories = actionCreator(type.REQUEST_CATEGORY);
export var successCategories = actionCreator(type.SUCCESS_CATEGORY);
export var failureCategories = actionCreator(type.FAILURE_CATEGORY);
export var requestCategoryDetail = actionCreator(type.REQUEST_CATEGORY_DETAIL);
export var successCategoryDetail = actionCreator(type.SUCCESS_CATEGORY_DETAIL);
export var failureCategoryDetail = actionCreator(type.FAILURE_CATEGORY_DETAIL);
export var requestBulkPrice = actionCreator(type.REQUEST_BULK_PRICE);
export var successBulkPrice = actionCreator(type.SUCCESS_BULK_PRICE);
export var failureBulkPrice = actionCreator(type.FAILURE_BULK_PRICE);